import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/sensor-alert'

export const get = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}
